<div class="identity-iframe-loading text-info-label-bold disable-select" *ngIf="isLoading">
  <img [src]="loadingLogo" draggable="false" *ngIf="loadingLogo" />
  <div>loading...</div>
</div>

<iframe class="identity-iframe" [ngStyle]="{'display': isLoading ? 'none' : 'inline'  }" id="identityFrame" (load)="identityIframeLoad()"></iframe>
